import { useShoppingBasketInfoWithDefaultData } from '#src/clientState/providers';
import { groupProductsByType } from '#src/utils';
import { useFlow } from '@edreamsodigeo/frontend-core';
import React, { memo, useMemo } from 'react';

import { DatameshComponentClick } from './DatameshComponentClick';
import { DatameshComponentLoad } from './DatameshComponentLoad';
import { DatameshIds } from './models';

const EmptyComponent = ({ children }) => children;
const EmptyComponentWithoutChildren = () => null;

export const DatameshTracking = memo(
  ({
    children,
    datameshId,
    load = false,
    click = false,
  }: {
    children: React.ReactNode;
    datameshId: DatameshIds;
    load?: boolean;
    click?: boolean;
  }) => {
    const { loading, products } = useShoppingBasketInfoWithDefaultData();
    const flow = useFlow();
    const dataMeshFlow = useMemo(
      () => (flow === 'desktop' ? 'DESKTOP' : 'MOBILE'),
      [flow]
    );
    const productsList = useMemo(
      () => groupProductsByType(products),
      [products]
    );
    const LoadTracking =
      load && !loading && productsList && productsList.length > 0
        ? DatameshComponentLoad
        : EmptyComponentWithoutChildren;
    const ClickTracking =
      click && !loading && productsList && productsList.length > 0
        ? DatameshComponentClick
        : EmptyComponent;

    return (
      <>
        <LoadTracking
          datameshId={datameshId}
          products={productsList}
          datameshFlow={dataMeshFlow}
        />
        <ClickTracking
          datameshFlow={dataMeshFlow}
          datameshId={datameshId}
          products={productsList}
        >
          {children}
        </ClickTracking>
      </>
    );
  }
);
